// extracted by mini-css-extract-plugin
module.exports = {"button_container":"CloseButton_button_container__3pZ4O","cross":"CloseButton_cross__2tSKP","progress_bar":"CloseButton_progress_bar__1vQhi"};